var _rect, _rect2, _polyline, _polyline2, _polyline3, _polyline4, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 66.9,
    viewBox: "0 0 70 66.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8.52,
    width: 38.1,
    height: 38.1,
    transform: "translate(-9.23 32.86) rotate(-45)",
    fill: "#fff",
    stroke: "#002953",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 8.2,
    width: 39.6,
    height: 39.6,
    transform: "translate(-9.55 32.95) rotate(-45)",
    fill: "none"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "28.89 13.82 28.79 21.42 28.79 22.62 40.89 22.72 40.89 22.72 40.99 13.62 43.79 16.42 34.99 7.62 34.99 7.62 25.99 16.42",
    fill: "none",
    stroke: "#002953",
    strokeMiterlimit: 10
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "18.29 24.62 18.19 32.22 18.19 33.42 30.29 33.52 30.29 33.52 30.39 24.42 33.19 27.22 24.39 18.42 24.39 18.42 15.39 27.22",
    fill: "none",
    stroke: "#002953",
    strokeMiterlimit: 10
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "39.39 24.62 39.39 32.22 39.39 33.42 51.49 33.52 51.49 33.52 51.59 24.42 54.39 27.22 45.49 18.42 45.49 18.42 36.49 27.22",
    fill: "none",
    stroke: "#002953",
    strokeMiterlimit: 10
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "28.89 34.62 28.79 42.22 28.79 43.42 40.89 43.52 40.89 43.52 40.99 34.42 43.79 37.22 34.99 28.42 34.99 28.42 25.99 37.22",
    fill: "none",
    stroke: "#002953",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.89,26.62s3.7-1.2,3.4,.6c-.3,1.4-1.5,.7-3-.2-1.6-1-6.7-5-10.2-9.9-1-1.5-.5-3.3-.2-3.6,.2-.2,1.3-.6,1.5,.5,.1,.7-3.2,5.3-3.2,5.3,0,0-5.6,6.3-7.4,7.3-.3,.2-.5,.2-.5,.1-.5-.8-2.1-1.8-3.4-1.2-.4,.2-1.2,.8,.1,1.2,1.4,.5,2.8,.3,3,.2s8.1,6.2,9.9,9.5c2,3.6,.5,3.8-.1,3.7,0,0-2.3,.3,.4-4,2.7-4.3,9.7-9.5,9.7-9.5Z",
    fill: "none",
    stroke: "#366ca2",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: 56,
    width: 101,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.7,64.4q0-.1,0,0l.7-.1h.1c.1,0,0,0,0,0l.3,1.8s0,.1,.1,.1,.2,.1,.4,.1c.1,0,.3,.1,.5,.1s.3,0,.5,.1h.5c.7,0,1.3-.1,1.9-.3,.5-.2,1-.5,1.4-.8,.4-.4,.7-.8,.8-1.3s.3-1.1,.3-1.8v-.3H2.9q-.1,0-.1-.1v-.6q0-.1,.1-.1H7.9c-.1-.6-.2-1.2-.5-1.7s-.5-1-.9-1.3c-.4-.4-.8-.7-1.3-.9s-1.1-.3-1.7-.3h-.3c-.1,0-.3,0-.5,.1s-.2,0-.4,.1-.3,.1-.5,.1c0,0-.1,0-.1,.1l-.3,1.9H.8q-.1,0-.1-.1v-2.5s0-.1,.1-.1c.3,0,.7-.1,1.2-.2s1.1-.1,1.8-.1c.9,0,1.6,.1,2.3,.4s1.3,.6,1.8,1.1,.9,1.1,1.1,1.7c.3,.7,.5,1.4,.5,2.2,0,.9-.2,1.7-.5,2.4s-.7,1.3-1.3,1.7-1.2,.8-1.9,1c-.7,.2-1.5,.3-2.3,.3h-.7c-.3,0-.5-.1-.7-.1-.3,0-.5-.1-.7-.1s-.4-.1-.6-.1q-.1,0-.1-.1s0-2.3,0-2.3Z",
    fill: "#fff",
    stroke: "blue",
    strokeMiterlimit: 10,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,56.5c1,0,1.7,.1,2.3,.3,1.3,.4,1.9,1.3,1.9,2.7,0,.9-.4,1.7-1.2,2.3-.7,.5-1.6,.8-2.5,.8l-1.6-.3v4s0,.1,.1,.1l1.5,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-4.3q-.1,0-.1-.1v-.4q0-.1,.1-.1l1.3-.1q.1,0,.1-.1v-9q0-.1-.1-.1l-1.3-.1q-.1,0-.1-.1v-.4q0-.1,.1-.1s3.8,0,3.8,0Zm-1,.8q-.1,0,0,0l-.1,4.5q0,.1,.1,.1h.9c1.8,0,2.8-.8,2.8-2.4,0-.8-.3-1.4-.9-1.7-.5-.3-1.2-.5-2-.5,0,0-.8,0-.8,0Z",
    fill: "#fff",
    stroke: "blue",
    strokeMiterlimit: 10,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1,67q-.1,0,0,0l-.1-.5q0-.1,.1-.1l1.2-.1h.1v-.1l-1.2-3.1h-3.6l-1.1,3.2q0,.1,.1,.1l1.2,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-3.4q-.1,0-.1-.1v-.4q0-.1,.1-.1l1.3-.1h.1l4-10h.6l3.6,10h.1l1.2,.1s.1,0,.1,.1v.4q0,.1-.1,.1h-4.2v-.1Zm-1.5-8.4s-.1,0,0,0h-.1l-1.5,3.7q0,.1,.1,.1h2.8q.1,0,.1-.1l-1.4-3.7Z",
    fill: "#fff",
    stroke: "blue",
    strokeMiterlimit: 10,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9,56.5s.1,.1,0,0l.1,.5q0,.1-.1,.1l-1.3,.1q-.1,0-.1,.1v3.9q0,.1,.1,.1c.3,0,.6,0,.8-.1s.5-.2,.7-.4,.4-.3,.5-.6c.2-.2,.3-.5,.5-.8l.8-1.6c.1-.3,.3-.5,.4-.7,.2-.2,.3-.4,.5-.5s.3-.2,.5-.3,.4-.1,.5-.1h.3c.1,0,.2,0,.3,.1,.1,0,.2,.1,.3,.1,.1,.1,.2,.1,.2,.2v.2l-.8,1c0,.1-.1,.1-.1,0-.1-.1-.2-.2-.3-.2s-.2-.1-.3-.1c-.2,0-.3,.1-.5,.2s-.3,.4-.5,.7l-.4,.8c-.1,.2-.2,.5-.4,.7-.1,.2-.3,.4-.4,.6-.2,.2-.3,.4-.5,.5s-.3,.3-.5,.3c.2,.1,.4,.1,.6,.2,.2,.1,.4,.2,.6,.4,.2,.2,.4,.4,.5,.6,.2,.2,.3,.5,.5,.8l1.5,2.8,.1,.1,1.1,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-2.5s-.1,0-.1-.1l-1.4-3c-.2-.5-.4-.8-.7-1.1-.2-.3-.4-.5-.7-.6-.2-.1-.4-.2-.6-.3s-.4-.1-.6-.1q-.1,0-.1,.1v4.3q0,.1,.1,.1l1.3,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-4.2q-.1,0-.1-.1v-.4q0-.1,.1-.1l1.3-.1q.1,0,.1-.1v-4.3q0-.1-.1-.1c-.2,0-.4,0-.6,.1s-.4,.1-.6,.3c-.2,.1-.4,.4-.7,.6-.2,.3-.4,.6-.7,1.1l-1.4,3-.1,.1h-2.4q-.1,0-.1-.1v-.4q0-.1,.1-.1l1.1-.1q.1,0,.1-.1l1.4-2.8c.2-.3,.3-.6,.5-.8s.4-.4,.5-.6c.2-.2,.4-.3,.6-.4,.2-.1,.4-.2,.6-.2-.1-.1-.3-.2-.5-.3-.2-.1-.3-.3-.5-.5s-.3-.4-.4-.6c-.1-.2-.3-.5-.4-.7v-.7c-.1-.3-.3-.6-.5-.7s-.3-.2-.5-.2c-.1,0-.2,0-.3,.1s-.2,.1-.3,.2h-.1l-.8-1v-.2l.2-.2c.1-.1,.2-.1,.3-.1s.2-.1,.3-.1h.3c.2,0,.4,0,.5,.1,.2,.1,.3,.2,.5,.3s.3,.3,.5,.5,.3,.5,.5,.7l.8,1.6c.1,.3,.3,.5,.5,.8,.2,.2,.3,.4,.5,.6s.4,.3,.6,.4c.2,.1,.5,.1,.8,.1,0,0,.1,0,.1-.1v-3.9q0-.1-.1-.1l-1.3-.1q-.1,0-.1-.1v-.4q0-.1,.1-.1h4v-.1Z",
    fill: "#fff",
    stroke: "blue",
    strokeMiterlimit: 10,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,56.5c.1,0,.1,.1,0,0l.1,.5q0,.1-.1,.1l-1.3,.1q-.1,0-.1,.1v3.9q0,.1,.1,.1c.3,0,.6,0,.9-.1,.3-.1,.5-.2,.7-.3,.2-.2,.4-.3,.6-.6,.2-.2,.3-.5,.5-.8l.8-1.6c.1-.3,.3-.5,.4-.7s.3-.4,.5-.5,.3-.2,.5-.3,.3-.1,.5-.1h.3c.1,0,.2,0,.3,.1,.1,0,.2,.1,.3,.1,.1,.1,.2,.1,.2,.2v.2l-.8,1s0,.1-.1,.1h-.1c-.1-.1-.2-.2-.3-.3-.1-.1-.2-.1-.3-.1-.2,0-.3,.1-.5,.2s-.3,.4-.5,.7l-.4,.8c-.1,.2-.2,.5-.4,.7s-.3,.5-.4,.6-.3,.4-.5,.5-.3,.2-.5,.3c.2,.1,.4,.1,.6,.2,.2,.1,.4,.2,.6,.4,.2,.2,.4,.4,.5,.6s.3,.5,.5,.8l1.5,2.8,.1,.1,1.1,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-2.4s-.1,0-.1-.1l-1.4-3c-.2-.5-.4-.8-.7-1.1-.2-.3-.5-.5-.7-.6s-.5-.2-.7-.3c-.2,0-.4-.1-.6-.1q-.1,0-.1,.1v4.3q0,.1,.1,.1l1.3,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-4.2q-.1,0-.1-.1v-.4q0-.1,.1-.1l1.3-.1q.1,0,.1-.1v-9q0-.1-.1-.1l-1.3-.1q-.1,0-.1-.1v-.4q0-.1,.1-.1h4.2v.1Z",
    fill: "#fff",
    stroke: "blue",
    strokeMiterlimit: 10,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,56.5c.1,0,.1,.1,0,0l.1,.5q0,.1-.1,.1l-1.1,.1h-.1v.1l2.1,3.4,2.4-3.4h0q0-.1-.1-.1l-1-.1q-.1,0-.1-.1v-.4q0-.1,.1-.1h3.3q.1,0,.1,.1v.4q0,.1-.1,.1l-1.2,.1h-.1l-2.9,4.2,3,4.9h.1l1.3,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-4.2q-.1,0-.1-.1v-.4q0-.1,.1-.1l1.1-.1h.1v-.1l-2.3-3.7-2.6,3.7v.1h.1l1.1,.1q.1,0,.1,.1v.4q0,.1-.1,.1h-3.3q-.1,0-.1-.1v-.4q0-.1,.1-.1l1.2-.1h.1l3.1-4.5-2.9-4.5h-.1l-1.3-.1q-.1,0-.1-.1v-.4q0-.1,.1-.1h4.2v-.1Z",
    fill: "#fff",
    stroke: "blue",
    strokeMiterlimit: 10,
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.67f2a5020f62485d0b765815eb5f7f2f.svg";
export { ForwardRef as ReactComponent };